import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=f8863f6e&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports